export default {
  small: 639,
  medium: 1023
};
